import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import './App.css';
import { NavigateFunction, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AppGeneralContext, AppGeneralContextProvider } from './shared/GeneralContext/GeneralContext';
import Header from './components/organism/header/Header';
import { BottomBarMenu, DropdownMenu, Modal } from './components/molecules';
import useMediaQuery from './hook/useMediaQuery';
import { MediaDesktop, MediaMobile, MediaTablet } from './api/const/MediaQuery';
import AsideMenu from './components/molecules/AsideMenu/AsideMenu';
import clsx from 'clsx';
import { Login, SelectDates } from './components/pagine';
import { Layout } from './components/templates/Layout';
import { DatesModal } from './components/pagine/DatesModal';

import { AuthInit, useAuth } from 'shared/auth';
import { useScrollBlock } from 'hook/useScrollBlock';
import { initialStateModal, ModalType } from 'components/types/types';
import { CircularProgress } from '@mui/material';
import { LoginType } from 'components/types/Context';
import ModalChildren from 'components/molecules/Modal/ModalChildren';
import { Button, Loader } from 'components/atoms';
import ChangePassword from 'components/molecules/ChangePassword/ChangePassword';
import { getAuth } from 'shared/auth/authHelpers';
import axios from 'axios';
import * as Sentry from "@sentry/react";
import ResetEmail from 'components/molecules/ResetEmail/ResetEmail';

Sentry.init({
  dsn: "https://471df0caadc7556367f3bee9968744b6@o4506694926139392.ingest.sentry.io/4506694927777792",
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/api.innovationmatch\.io\//],
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      networkDetailAllowUrls: [/^https:\/\/api.innovationmatch\.io\//],
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

function App() {
  const tablet = useMediaQuery(MediaTablet)
  const mobile = useMediaQuery(MediaMobile)
  const desktop = useMediaQuery(MediaDesktop)
  const location = useLocation()
  const navigate = useNavigate()
  const [isPlatform, setIsPlatform] = useState<boolean>(false)
  const { changePWisOpen,resetEmailisOpen, setresetEmailisOPen,setstartUpIdforMatch, setchangePWisOpen, modal, setModal, modalDatesIsOpen, setModalDatesIsOpen, loginType, setLoginType, matchSelected, modalChildren, setModalChildren } = useContext(AppGeneralContext)
  
  const { auth, logout } = useAuth()


  const handleNotAuthorized =
    (navigate?: NavigateFunction, prevPath?: string, logout?: () => void) => {
      const auth = getAuth()

      // logout?.()

      if (!!auth?.isStartUp) {
        navigate?.("/login-startup", { state: { prevPath } })
      } else {
        navigate?.("/login-corporate", { state: { prevPath } })
      }
    }


  useEffect(() => {
    axios.interceptors.response.use(
      async (response) => {
        return response
      },

      async (error) => {

        if (error.response.status === 401) {
          setModal({
            isOpen: true, type: ModalType.error,
            title: "Please Login",
            message: "You are currently disconnected. Please login or register in order to access the Innovation Match platform.",
            onCloseNotAuthorized: handleNotAuthorized
          })
          return Promise.reject(error)

        } else {
          return Promise.reject(error);
        }
      });
  }, [])


  const [imageLoaded, setImageLoaded] = useState(false)

  useEffect(() => {
    let route = loginType === LoginType.startup ? "start-up" : "corporate"

    if (location.pathname.toLowerCase().includes(`/${route}/profile/messaging`)) {
      if (!tablet) {
        return navigate(`/${route}/profile`)
      }
      return
    }
    return
  }, [tablet, loginType, location])


  useEffect(() => {
    const match = location.pathname.toLowerCase().includes(`corporate/match/`)
    const preview = location.pathname.toLowerCase().includes(`corporate/startup-profile/`)

    if (!loginType && !auth &&
      !location.pathname.toLowerCase().includes(`/getstarted`)
      && !location.pathname.toLowerCase().includes('/linkedin')
    ) {

      if (location.pathname.toLowerCase().includes(`corporate`)) {
        if (preview) {
          setLoginType(LoginType.guest);
          return
        }

        if (match) {
          setModalDatesIsOpen(true);
          setLoginType(LoginType.guest);
          return
        } else {
          setModalDatesIsOpen(false);
          setstartUpIdforMatch("")
        }


        setLoginType(LoginType.corporate)
        return navigate(`/login-corporate`) //🤦‍♂️
      }

      if (location.pathname.toLowerCase().includes(`startup`)) {
        setLoginType(LoginType.startup)
        return navigate(`/login-startup`) //🤦‍♂️
      }

      return navigate(`/login`) //🤦‍♂️

    }
  }, [loginType, auth, location.pathname])

  useEffect(() => {
    const login = location.pathname.toLowerCase().includes(`login`)
    if (login) {
      setModalDatesIsOpen(false);
      setstartUpIdforMatch("")
    }
  }, [location.pathname])

  const showBar = useMemo(() => {
    if (location.pathname === '/' ||
      location.pathname.toLowerCase().includes('/login') ||
      location.pathname.toLowerCase().includes('/getstarted') ||
      location.pathname.toLowerCase().includes('/linkedin')) {

      return

    } else {

      if (tablet || mobile) {
        return <BottomBarMenu />
      }

    }
  }, [tablet, mobile, location.pathname])

  useEffect(() => {

    if (location.pathname === '/' ||
      location.pathname.toLowerCase().includes('/login') ||
      location.pathname.toLowerCase().includes('/getstarted') ||
      location.pathname.toLowerCase().includes('/linkedin')) {
      setIsPlatform(false)
    } else {
      setIsPlatform(true)
    }

  }, [location.pathname])


  return (
    <AuthInit>
      <Layout isPlatform={isPlatform} />
      <DatesModal modalIsOpen={modalDatesIsOpen} setModalIsOpen={setModalDatesIsOpen}>
        <SelectDates />
      </DatesModal>
      <Modal
        message
     isOpen={modal.isOpen}

        onClose={() => {
          modal?.onCloseNotAuthorized?.(navigate, location.pathname, logout);
          modal?.onCloseCallback?.();
          setModal(initialStateModal)
        }}
        childComponent={
          <div className=''>
            <div className="d-flex justify-content-center align-items-center">
              {/* <h1 className='tx-primary text-center'>{"modal.title"}</h1> */}
              {modal.type === ModalType.loading ?
                // <CircularProgress style={{ height: "20px", width: "20px", marginLeft: "10px" }} color="primary" />
                <Loader/>
                :
                <h1 className='tx-primary text-center'>{modal.title}</h1>
              }
               
            </div>
            <div className="tx-white text-center">
              {modal.message.split('\n').map((x, i) => <p key={i}>{x}</p>)}
            </div>
            {(modal.title === "Please Login" || modal.title === "The email is already registered") &&
              <div className="tx-white text-center">
                <Button color='var(--white)'
                  background='var(--primary)'
                  borderColor='var(--primary)'
                  fontWeight={'800'}
                  uppercase
                  primary
                  text='Log In'
                  onClick={() => {

                    setModal(initialStateModal);
                    setModalDatesIsOpen(false)
                    if (!auth?.jwtToken) {
                      navigate(`/login-corporate`)
                    } else {
                      navigate("/login");
                    }
                  }} />
              </div>}
          </div>
        }
      />
      <ModalChildren
        title={modalChildren.title}
        modalIsOpen={modalChildren.modalIsOpen}
        setModalIsOpen={setModalChildren}
        closeButton={modalChildren.closeButton}
      >
        <img onLoad={() => { setImageLoaded(true) }} className="img-plans" src="/img/plansTable.png" alt="plans" />
        {!imageLoaded &&
          <Loader />
        }
        {modalChildren.children}
      </ModalChildren>
      <Modal
        message
        isOpen={changePWisOpen}
        onClose={() => { setchangePWisOpen(false) }}
        childComponent={
          <ChangePassword />
          
        }
      />
      <Modal
        message
        isOpen={resetEmailisOpen}
        onClose={()=>{setresetEmailisOPen(false)}}
        childComponent={
          <ResetEmail />
        } 
        />
      {showBar}
    </AuthInit >
  );
}

export default App;

